import React from 'react';
import image1 from '../assets/1.jpg';
import image2 from '../assets/2.jpg';
import image3 from '../assets/3.jpg';
import image4 from '../assets/4.jpg';
import image5 from '../assets/5.jpg';
import image6 from '../assets/6.jpg';
import image7 from '../assets/7.jpg';
import image8 from '../assets/8.jpg';
import image9 from '../assets/cnfz.png';

const Uploads = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6 text-white">Uploads</h1>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div className="relative group">
            <img src={image1} alt="1.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image2} alt="2.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image3} alt="3.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image4} alt="4.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image5} alt="5.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image6} alt="6.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image7} alt="7.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image8} alt="8.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
          <div className="relative group">
            <img src={image9} alt="8.jpg" className="w-full h-64 object-cover rounded-lg transition-transform duration-300 hover:scale-105" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Uploads;